import { absoluteUrl, siteUrl } from '@src/lib/seo/config';

/**
 * Titles pair the product with "Cardano" deliberately. The bare string
 * "DRep ID" collides with the DREP token, with drep.org (an unrelated identity
 * project) and with the generic Cardano term for a bech32 DRep identifier —
 * the brand does not disambiguate itself without the network name.
 */
const seoConstants = {
  appName: 'DRep ID',
  // Kept under 155 characters. Google truncates the description around there,
  // and the previous 181-character string lost its final clause in the SERP
  // snippet. Anything added here has to come out of something else.
  appDesc:
    'Browse Cardano DReps and governance actions, compare voting records and voting power, then delegate your ADA or create a unique, URL-friendly DRep ID.',
  title: 'DRep ID — Cardano DReps, Governance Actions & Delegation',
  titleTemplate: '%s | DRep ID',
  favIcon: 'favIcon',
  twitterHandle: '@SiretoTech',
  titleImg: 'titleImg',
  socialPreview: {
    url: `${siteUrl}/`,
    title: 'DRep ID — Cardano DReps, Governance Actions & Delegation',
    // Deliberately the same string as `appDesc`. Two descriptions that differ
    // only in wording gave the SERP snippet and the social card different
    // claims about what the site does.
    desc: 'Browse Cardano DReps and governance actions, compare voting records and voting power, then delegate your ADA or create a unique, URL-friendly DRep ID.',
    // Resolved against the running deployment. This was previously hardcoded
    // to preview.drep.id, so production shipped a testnet asset in every card.
    bannerImage: absoluteUrl('/banner.png'),
  },
  keywords: [
    'cardano drep',
    'cardano drep list',
    'drep directory',
    'cardano governance',
    'cardano governance actions',
    'delegate ada voting power',
    'cardano voting power',
    'ada delegation',
    'cip-1694',
    'cardano constitution',
    'treasury withdrawal cardano',
    'delegated representative cardano',
    // The registration side of the product. The list above covers only the
    // directory, so a visitor searching for how to claim a handle matched
    // nothing in the title, description or keywords.
    'create drep id',
    'unique drep id',
    'url-friendly drep identity',
    'connect cardano wallet',
  ],
};

export default seoConstants;
